import { money, x2, num, monthLabel, Delta, roasTone } from "./roasUtil";

function MonthTarget({ m, onSave }) {
  return (
    <input type="number" step="0.1" min="0" className="w-14 px-1.5 py-0.5 rounded border text-xs tabular-nums bg-transparent"
      defaultValue={m.month_target ?? ""} placeholder={m.target_roas ?? "\u2014"} key={`${m.month}-${m.month_target}`}
      onBlur={(e) => e.target.value !== String(m.month_target ?? "") && onSave(m.month, e.target.value)}
      onKeyDown={(e) => e.key === "Enter" && e.currentTarget.blur()} data-testid={`roas-month-target-${m.month}`} />
  );
}

export function RoasMonths({ months, avgDeal, onMonthTarget }) {
  const rows = [...months].reverse();
  return (
    <section className="panel p-4 overflow-x-auto" data-testid="roas-months">
      <div className="text-sm font-medium mb-1">Month by month</div>
      <div className="text-xs text-[var(--text-dim)] mb-3">Sales count in the month the lead came in. Leave a month's target blank to use the default.</div>
      <table className="w-full text-xs tabular-nums min-w-[820px]">
        <thead className="text-[var(--text-dim)] text-left">
          <tr>{["Month", "Spend", "Leads", "Won", "Sales", "ROAS", "Target", "Short by", "Deals needed", "Spend cap at target", "CPL"].map((h) => <th key={h} className="py-1.5 pr-3 font-normal">{h}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((m, i) => {
            const prev = rows[i + 1];
            const need = m.deficit && avgDeal ? Math.ceil(m.deficit / avgDeal) : null;
            return (
              <tr key={m.month} className="border-t border-[var(--border)]" data-testid={`roas-month-${m.month}`}>
                <td className="py-1.5 pr-3 font-medium">{monthLabel(m.month)}</td>
                <td className="pr-3">{money(m.spend)} <Delta cur={m.spend} prev={prev?.spend} invert /></td>
                <td className="pr-3">{num(m.leads)}</td>
                <td className="pr-3">{num(m.won)}</td>
                <td className="pr-3">{money(m.revenue)} <Delta cur={m.revenue} prev={prev?.revenue} /></td>
                <td className={`pr-3 font-medium ${roasTone(m.roas, m.target_roas)}`}>{x2(m.roas)} <Delta cur={m.roas} prev={prev?.roas} /></td>
                <td className="pr-3"><MonthTarget m={m} onSave={onMonthTarget} /></td>
                <td className={`pr-3 ${m.deficit ? "text-[var(--breach)]" : m.target_roas && m.spend ? "text-[var(--ok)]" : ""}`}>{m.target_roas && m.spend ? (m.deficit ? money(m.deficit) : "Hit") : "\u2014"}</td>
                <td className="pr-3">{need ?? "\u2014"}</td>
                <td className="pr-3">{m.target_roas ? money(m.max_spend_for_target) : "\u2014"}</td>
                <td className="pr-3">{money(m.cpl)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
}
